// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-page-js" + "-" + "a579f0ed3ab357bb08aa" + ".js";
};